import { LmFormErrors } from '@/lib/models/lm-form-errors.class'
import { createFormData } from '@/utils/create-form-data'

export class LmFormObject {
  constructor(data) {
    this.originalData = data

    Object.keys(data).map(field => {
      this[field] = data[field]
    })

    this.errors = new LmFormErrors()
    this.getFormData = createFormData
  }

  data() {
    let data = {}

    Object.keys(this.originalData).map(field => {
      data[field] = this[field]
    })

    return data
  }

  reset() {
    Object.keys(this.originalData).map(field => {
      this[field] = null
    })

    this.errors.clear()
  }

  submit(event, payload, ref) {
    ref.$emit(event, payload)
  }
}
